<template>
  <div class="p-4">
    <h1 class="text-2xl font-semibold mb-4">Sites</h1>

    <EditableGrid
        :fetch-data-query="listQuery"
        :update-mutation="updateMutation"
        :column-defs="columnDefs"
        :search-fields="['hospital_id', 'hospital_name', 'city', 'state', 'zip', 'domain']"
        primary-key="hospital_id"
        :components="gridComponents"
        :context="gridContext"
    />
  </div>
</template>

<script>
import EditableGrid from "@/components/common/EditableGrid.vue";
import RolesTooltip from "@/components/sites/RolesTooltip.vue";
import RolesEditor from "@/components/sites/RolesEditor.vue";
import TagConfigEditor from "@/components/sites/TagConfigEditor.vue";
import ListSizeRenderer from "@/components/common/ListSizeRenderer.vue";

import {listHospitals, updateHospitals} from '@/graphql/hospitals.graphql';

export default {
  name: 'ReportsPage',
  components: {
    EditableGrid,
  },
  data() {
    return {
      rolesEditor: {
        isOpen: false,
        value: [],
      },
      listQuery: listHospitals,
      updateMutation: updateHospitals,
      // Column Definitions
      columnDefs: [
        {headerName: 'Hospital ID', field: 'hospital_id', tooltipField: 'hospital_id', editable: false},
        {headerName: 'Name', field: 'hospital_name', tooltipField: 'hospital_name'},
        {headerName: 'Display', field: 'display'},
        {headerName: 'Paused', field: 'paused'},
        {headerName: 'Waitlist', field: 'waitlist'},
        {headerName: 'Excl from Leaderboards', field: 'exclude_from_leaderboards'},
        {headerName: 'Poll Set', field: 'poll_set'},
        {headerName: 'Email Domain', field: 'domain'},
        {headerName: 'Tags?', field: 'use_user_tags'},
        {headerName: 'Tag Label', field: 'tag_label'},
        {headerName: 'Tag Prompt', field: 'tag_prompt'},
        {headerName: 'Tags', field: 'hospital_tags', cellRenderer: 'ListSizeRenderer', cellEditor: "TagConfigEditor"},
        {headerName: 'Roles', field: 'roles', sortable: false, cellEditor: 'RolesEditor', cellRenderer: 'ListSizeRenderer', tooltipComponent: 'RolesTooltip', tooltipField: 'roles'},
        {headerName: 'City', field: 'city'},
        {headerName: 'State', field: 'state'},
        {headerName: 'Zip', field: 'zip'},
        {headerName: 'AHA Name', field: 'aha_name'},
      ],
      gridComponents: {
        RolesTooltip,
        RolesEditor,
        ListSizeRenderer,
        TagConfigEditor
      },
      gridContext: {
        componentParent: this, // Will be set in mounted()
      },
    };
  },
};
</script>

<style scoped>
</style>
